import { Button, Form, Image } from "antd";
import LoginTemplate from "../../templates/LoginTemplate";
import { useEffect, useState } from "react";
import { InputField } from "../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { forgotPassword } from "../Login/ducks/services";
import { AxiosError, AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";

interface FormValues {
  email: string;
}

export default function ForgotPassword() {
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isValid },
  } = useForm<FormValues>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  const onSubmit = (val: { email: string }) => {
    setLoading(true);
    forgotPassword(val)
      .then((res: AxiosResponse) => {
        if (res?.data?.success) {
          setLoading(false);
          // SuccessMessage(
          //   res?.data?.message ?? "Reset Password instructions sent."
          // );
          navigate("/login", { state: { id: 1, name: "reset" } });
        } else {
          setLoading(false);
          // ErrorMessage(res?.data?.message ?? "Something went wrong");
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          // ErrorMessage(
          //   e?.response?.data?.error?.message ?? "Something went wrong"
          // );
        } else {
          setLoading(false);
          // ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <LoginTemplate loading={loading}>
      <div className="loginForm">
        <div className="loginLogo">
          <Image src="/images/login/logo.svg" alt="Logo" preview={false} />
        </div>

        <h1> Reset password </h1>
        <p>
          Enter your email, and we’ll send you instructions to reset your
          password.
        </p>

        <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
          <InputField
            fieldName="email"
            label="Email"
            control={control}
            className="requiredInput mb_24"
            defaultValue=""
            iProps={{
              placeholder: "Enter email",
              autoComplete: "Email",
            }}
            isRequired
            rules={{
              required: "Email is required.",
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Incorrect email address.",
              },
            }}
            validate={errors.email && "error"}
            validMessage={errors.email && errors.email.message}
          />

          <Button
            htmlType="submit"
            type="primary"
            disabled={!isDirty || !isValid}
          >
            Send instructions
          </Button>
        </Form>
      </div>
    </LoginTemplate>
  );
}
